export const contentOptionMap = {
  0: '합',
  1: '충',
  2: '형파해',
  3: '신살',
  4: '육친',
  5: '원귀공태',
}